import { ColorAndSize } from '../types';

export const calculateQuantity = (colorsAndSizes: ColorAndSize[]) =>
    colorsAndSizes.reduce((acc, colorAndSize) => {
        return acc + colorAndSize.sizes.reduce((acc, size) => acc + size.quantity, 0);
    }, 0);
